import { createUseStyles } from 'react-jss';

import { ROUTE_NAV_CONTENT_GAP } from './maxPageWidthShell.styles';

/** Shared max-width constraint for page layouts (legacy JSS object shape). */
export const maxPageWidthStyles = {
  maxWidth: 1216,
  margin: '0 auto',
};

/** Horizontal inset + max width for route content columns (matches `MaxPageWidth` `centered`). */
export const maxPageWidthCenteredStyleSheet = {
  boxSizing: 'border-box',
  display: 'flex',
  flex: 1,
  margin: '0 clamp(16px, 4vw, 32px)',
  maxWidth: 1216,
} as const;

export const useMaxPageWidthStyles = createUseStyles({
  root: {
    display: 'flex',
    padding: `${ROUTE_NAV_CONTENT_GAP}px 0`,
    position: 'relative',
    boxSizing: 'border-box',
    justifyContent: 'center',
  },
  centered: maxPageWidthCenteredStyleSheet,
});

export type MaxPageWidthClasses = Partial<ReturnType<typeof useMaxPageWidthStyles>>;
